import React, { useEffect, useState } from "react";
import { Form, Input, Select, Button, Row, Col, Modal, notification } from "antd";
import { assignDriverToVehicle, assignDriverToVehicleCheck } from "../../../api/vehicles.service";
import { getDrivers } from "../../../api/user.service";

const AssignDriverToVehicleFormModal = ({ fetchAllVehicles, vehicleData, onClose, isModalOpen, setIsModalOpen, handleOk, handleCancel, isViewOnly = false }) => {
    const [form] = Form.useForm();
    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (vehicleData) {
            form.setFieldsValue({
                selectedDriverId: vehicleData.driverId || undefined, // Ensure it's properly set
            });
        } else {
            form.resetFields();
        }
    }, [vehicleData, form]);

    const handleConfirm = async (values) => {


        try {
            let data = await assignDriverToVehicle({
                vehicleId: vehicleData?.id,
                driverId: values?.selectedDriverId
            });

            notification.success({ message: "Driver Assigned Successfully" });
            fetchAllVehicles();
            setIsModalOpen(false);
            console.log("Confirmed");
        } catch (error) {
            notification.error({ message: "Driver Assigned Failed" });
            setIsModalOpen(false);
        }
    }

    const onFinish = async (values) => {
        try {
            let data = await assignDriverToVehicleCheck({
                vehicleId: vehicleData?.id,
                driverId: values?.selectedDriverId
            });
            let alreadyAssigned = data?.data?.alreadyAssigned
            if (alreadyAssigned) {
                Modal.confirm({
                    title: "Warning",
                    content: "This driver is already assigned to vehicle with registration no : " + data?.data?.registrationNo + ", selecting this may result in a timing clash, Are you sure you want to proceed?",
                    okText: "Confirm",
                    cancelText: "Cancel",
                    onOk() {
                        handleConfirm(values)
                    },
                    onCancel() {
                        console.log("Cancelled");
                    },
                });
            }
            else {
                Modal.confirm({
                    title: "Warning",
                    content: "Are you sure you want to proceed?",
                    okText: "Confirm",
                    cancelText: "Cancel",
                    onOk() {
                        handleConfirm(values)
                    },
                    onCancel() {
                        console.log("Cancelled");
                    },
                });
            }
        } catch (error) {
            notification.error({ message: "Operation failed!" });
            console.error("Error:", error);
        }
    };

    const fetchVehicles = async () => {
        try {
            const response = await getDrivers();
            setOptions(
                response?.data?.map((elem) => ({
                    value: elem.id,
                    label: elem.name,
                })) || []
            );
        } catch (err) {
            notification.error({ message: "Failed to fetch drivers" });
        }
    };

    useEffect(() => {
        fetchVehicles();
    }, []);

    return (
        <>
            <Modal
                footer={null}
                destroyOnClose
                title={`Assign Driver`}
                open={isModalOpen}
                onCancel={handleCancel}
            >
                <Form
                    disabled={isViewOnly}
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    initialValues={{ selectedDriverId: "" }} // Ensure default values
                >
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label="Select Driver"
                                name="selectedDriverId"
                                rules={[{ required: true, message: "Please select driver" }]}
                            >
                                <Select
                                    className="vt-sel"
                                    placeholder="Select driver"
                                    options={options}
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    {!isViewOnly && (
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    )}
                </Form>
            </Modal>
        </>
    );
};

export default AssignDriverToVehicleFormModal;
